import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ComplianceFramework, ComplianceFrameworkCreate, ComplianceFrameworkFilter } from '../data/complianceFramework';

export function createComplianceFrameworkService(client: AxiosInstance) {
  return createCrudService<ComplianceFramework, ComplianceFrameworkCreate, ComplianceFrameworkFilter>(
    client,
    '/audit/ComplianceFramework',
    'id',
  );
}

export type ComplianceFrameworkService = CrudService<ComplianceFramework, ComplianceFrameworkCreate, ComplianceFrameworkFilter>;
